export default {
    // user
    userName: state => state.user.userName,
    userAge: state => state.user.userAge,
    // permission
    isSuperAdmin: state => state.permission.isSuperAdmin
};
